import { Link } from "react-router-dom";
import { useAuthState } from "../shared/auth/AuthContext";

export function HomeRoute() {
  const auth = useAuthState();

  return (
    <section>
      <h1 style={{ color: "var(--color-text)", marginTop: 0 }}>Berry Buds Web</h1>
      <p style={{ color: "var(--color-text-sub)" }}>
        この Web アプリは現在準備中です。当面は、モバイルアプリで蓄積したデータを PC
        にエクスポートするための入口として機能します。
      </p>
      <div style={{ marginTop: "var(--space-5)" }}>
        {auth.status === "authenticated" ? (
          <Link
            to="/export"
            style={{
              display: "inline-block",
              backgroundColor: "var(--color-primary)",
              color: "var(--color-text-on-primary)",
              padding: "var(--space-3) var(--space-5)",
              borderRadius: "var(--radius)",
              textDecoration: "none",
            }}
          >
            エクスポートを開く
          </Link>
        ) : (
          <Link
            to="/login"
            style={{
              display: "inline-block",
              backgroundColor: "var(--color-primary)",
              color: "var(--color-text-on-primary)",
              padding: "var(--space-3) var(--space-5)",
              borderRadius: "var(--radius)",
              textDecoration: "none",
            }}
          >
            ログイン
          </Link>
        )}
      </div>
    </section>
  );
}
